import { CSSProperties } from "react";
import clsx from "clsx";
// MUI
import { Grid, Tooltip, Typography } from "@mui/material";

// Helpers
import { toDateDiffDaysHoursMins } from "@/Common/helpers/Dates";

// Icons
import TimerOutlinedIcon from "@mui/icons-material/TimerOutlined";

// Types
type DateDiffProps = Readonly<{
	date: string | Date;
	color?: string;
	noTooltip?: boolean;
	classNameClock?: string;
	classNameTitle?: string;
	marginLeft?: string;
	maxWidth?: string;
	containerProps?: CSSProperties;
}>;

export default function DateDiff(props: DateDiffProps) {
	const {
		date,
		color = "",
		classNameClock = "",
		classNameTitle = "",
		marginLeft = "2px",
		maxWidth = "68px",
		containerProps = {},
		noTooltip = false,
	} = props;

	return (
		<Tooltip title={noTooltip ? "" : toDateDiffDaysHoursMins(date)} placement="right">
			<Grid container direction="row" alignItems="center" sx={{ color, ...(containerProps ?? {}) }}>
				<Grid item className="ms-1">
					<TimerOutlinedIcon sx={{ width: "13px", height: "13px" }} className={classNameClock} />
				</Grid>
				<Grid item sx={{ marginLeft: marginLeft ?? "2px", maxWidth: maxWidth ?? "68px" }}>
					<Typography
						className={clsx({
							"date-diff": true,
							[classNameTitle ?? ""]: Boolean(classNameTitle),
						})}
						sx={{ color }}
						component={"div"}
						noWrap
					>
						{toDateDiffDaysHoursMins(date)}
					</Typography>
				</Grid>
			</Grid>
		</Tooltip>
	);
}
